module.exports = __webpack_public_path__ + "static/media/mani.de758005.jpg";